"use strict";

var _defineProperty = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$DEFAULT_COUN;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDefaultCountryForBrand = exports.getDefaultCountryForBrand = exports.DEFAULT_COUNTRY_BY_BRAND = void 0;

var types_1 = require("../types");

exports.DEFAULT_COUNTRY_BY_BRAND = (_exports$DEFAULT_COUN = {}, _defineProperty(_exports$DEFAULT_COUN, types_1.Brand.BK, types_1.IsoCountryCode2Char.US), _defineProperty(_exports$DEFAULT_COUN, types_1.Brand.LTW, types_1.IsoCountryCode2Char.US), _defineProperty(_exports$DEFAULT_COUN, types_1.Brand.PLK, types_1.IsoCountryCode2Char.US), _defineProperty(_exports$DEFAULT_COUN, types_1.Brand.TH, types_1.IsoCountryCode2Char.CA), _exports$DEFAULT_COUN);
/**
 * Determine the default country value for a Brand.
 *
 * @param {Brand} brand
 * The Brand.
 *
 * @returns {IsoCountryCode2Char}
 * The default 2-character ISO country code for the Brand.
 */

var getDefaultCountryForBrand = function getDefaultCountryForBrand(brand) {
  return exports.DEFAULT_COUNTRY_BY_BRAND[brand];
};

exports.getDefaultCountryForBrand = getDefaultCountryForBrand;
/**
 * Given a country value, determine if it is the default country for a Brand.
 *
 * @param {Brand} brand
 * The Brand.
 *
 * @param {IsoCountryCode2Char | string} country
 * A country value.
 *
 * @returns {boolean}
 * true - The country value is the default for the Brand.
 * false - Otherwise.
 */

var isDefaultCountryForBrand = function isDefaultCountryForBrand(brand, country) {
  return exports.getDefaultCountryForBrand(brand) === country;
};

exports.isDefaultCountryForBrand = isDefaultCountryForBrand;